/* The hold line under the summary (prototype .rail .hold) and the warning's place over the steps, in the telify layer. */
@layer telify {
  .hold {
    margin-top: 18px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: var(--text-secondary);
  }

  .hold svg {
    color: var(--accent);
  }

  .warning {
    position: relative;
    margin-bottom: 20px;
  }

  /* The desktop column's banner floats over the column's top, under the site header while scrolling, and moves nothing. */
  .over {
    position: sticky;
    top: calc(var(--head-h) + 12px);
    height: 0;
    margin-bottom: 0;
    z-index: 30;
  }
}
